import React from 'react';
import { makeStyles } from '@material-ui/core';
import Divider from './Divider';

const useStyle = ({ fontSize = '60px', align = 'center', largeMode, multiLine }) =>
	makeStyles(theme => {
		const {
			palette,
			breakpoints: { down },
			spacing,
		} = theme;
		return {
			root: {
				display: 'flex',
				flexFlow: 'column',
				alignItems: largeMode ? 'left' : 'center',
				justifyContent: 'center',
				width: '100%',
				[largeMode && down('sm')]: {
					borderLeft: `4px solid ${palette.action.main}`,
					marginBottom: spacing(3),
				},
			},
			title: {
				fontFamily: 'BodoniMT',
				fontSize: largeMode ? '4.2rem' : '2.8rem',
				textAlign: largeMode ? 'left' : align,
				fontWeight: '300',
				whiteSpace: multiLine ? 'nowrap' : 'default',
				[down('sm')]: {
					textAlign: largeMode ? 'left' : align,
					fontSize: `${largeMode ? 2.3 : 1.5}rem`,
					padding: spacing(1, 0.25),
					paddingLeft: spacing(largeMode ? 3 : 0.25),
				},
			},

			divider: {
				width: '300px',
				margin: '40px 0',
				[down('sm')]: {
					margin: spacing(1, 0, 5, 0),
					display: largeMode ? 'none' : 'block',
				},
			},
		};
	});

const SectionTitle = ({
	multiLineTitle,
	title,
	fontSize,
	align,
	largeMode = false,
	className = '',
}) => {
	const classes = useStyle({ fontSize, align, largeMode, multiLine: multiLineTitle })();
	return (
		<div className={[classes.root, className].join(' ')}>
			{title && <p className={classes.title}>{title}</p>}
			{multiLineTitle &&
				multiLineTitle.map(line => <div className={classes.title}>{line}</div>)}
			<Divider className={classes.divider} />
		</div>
	);
};

export default SectionTitle;
